import React from "react";

import { Flex, Icon, Text } from "@chakra-ui/react";

/**
 * Component for displaying a preference item in the view menu
 * @param {Object} props - Component props
 * @param {string} props.title - The text to display
 * @param {React.ComponentType} props.icon - The icon component to display
 * @param {() => void} props.handler - Function to call when the item is clicked
 * @see src/components/companies/companiesList/newCompaniesList/viewListTools/viewMenu/ViewMenuItem.jsx
 * @see src/components/companies/companiesList/newCompaniesList/viewListTools/viewMenu/AddViewItem.jsx
 */
const ViewPreferenceItem = ({ 
  title, 
  icon, 
  handler 
}: { 
  title: string; 
  icon: React.ComponentType; 
  handler: () => void;
}) => {
  return (
    <Flex
      align={"center"}
      justify={"center"}
      onClick={handler}
      cursor={"pointer"}
      h={"31px"}
      minW={"fit-content"}
      borderRadius={"4px"}
      columnGap={"4px"}
    >
      <Icon as={icon} />
      <Text
        mt={"2px"}
        fontSize={"14px"}
        fontWeight={"400"}
        lineHeight={"1.35"}
        letterSpacing={"2%"}
      >
        {title}
      </Text>
    </Flex>
  );
};

export default ViewPreferenceItem;
